/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createPlayerConstruct = /* GraphQL */ `mutation CreatePlayerConstruct(
  $input: CreatePlayerConstructInput!
  $condition: ModelPlayerConstructConditionInput
) {
  createPlayerConstruct(input: $input, condition: $condition) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlayerConstructMutationVariables,
  APITypes.CreatePlayerConstructMutation
>;
export const updatePlayerConstruct = /* GraphQL */ `mutation UpdatePlayerConstruct(
  $input: UpdatePlayerConstructInput!
  $condition: ModelPlayerConstructConditionInput
) {
  updatePlayerConstruct(input: $input, condition: $condition) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlayerConstructMutationVariables,
  APITypes.UpdatePlayerConstructMutation
>;
export const deletePlayerConstruct = /* GraphQL */ `mutation DeletePlayerConstruct(
  $input: DeletePlayerConstructInput!
  $condition: ModelPlayerConstructConditionInput
) {
  deletePlayerConstruct(input: $input, condition: $condition) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlayerConstructMutationVariables,
  APITypes.DeletePlayerConstructMutation
>;
export const createLeaguePlayerStats = /* GraphQL */ `mutation CreateLeaguePlayerStats(
  $input: CreateLeaguePlayerStatsInput!
  $condition: ModelLeaguePlayerStatsConditionInput
) {
  createLeaguePlayerStats(input: $input, condition: $condition) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeaguePlayerStatsMutationVariables,
  APITypes.CreateLeaguePlayerStatsMutation
>;
export const updateLeaguePlayerStats = /* GraphQL */ `mutation UpdateLeaguePlayerStats(
  $input: UpdateLeaguePlayerStatsInput!
  $condition: ModelLeaguePlayerStatsConditionInput
) {
  updateLeaguePlayerStats(input: $input, condition: $condition) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeaguePlayerStatsMutationVariables,
  APITypes.UpdateLeaguePlayerStatsMutation
>;
export const deleteLeaguePlayerStats = /* GraphQL */ `mutation DeleteLeaguePlayerStats(
  $input: DeleteLeaguePlayerStatsInput!
  $condition: ModelLeaguePlayerStatsConditionInput
) {
  deleteLeaguePlayerStats(input: $input, condition: $condition) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeaguePlayerStatsMutationVariables,
  APITypes.DeleteLeaguePlayerStatsMutation
>;
export const createLeaguePointAdjustment = /* GraphQL */ `mutation CreateLeaguePointAdjustment(
  $input: CreateLeaguePointAdjustmentInput!
  $condition: ModelLeaguePointAdjustmentConditionInput
) {
  createLeaguePointAdjustment(input: $input, condition: $condition) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeaguePointAdjustmentMutationVariables,
  APITypes.CreateLeaguePointAdjustmentMutation
>;
export const updateLeaguePointAdjustment = /* GraphQL */ `mutation UpdateLeaguePointAdjustment(
  $input: UpdateLeaguePointAdjustmentInput!
  $condition: ModelLeaguePointAdjustmentConditionInput
) {
  updateLeaguePointAdjustment(input: $input, condition: $condition) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeaguePointAdjustmentMutationVariables,
  APITypes.UpdateLeaguePointAdjustmentMutation
>;
export const deleteLeaguePointAdjustment = /* GraphQL */ `mutation DeleteLeaguePointAdjustment(
  $input: DeleteLeaguePointAdjustmentInput!
  $condition: ModelLeaguePointAdjustmentConditionInput
) {
  deleteLeaguePointAdjustment(input: $input, condition: $condition) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeaguePointAdjustmentMutationVariables,
  APITypes.DeleteLeaguePointAdjustmentMutation
>;
export const createEventPlayerResult = /* GraphQL */ `mutation CreateEventPlayerResult(
  $input: CreateEventPlayerResultInput!
  $condition: ModelEventPlayerResultConditionInput
) {
  createEventPlayerResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventPlayerResultMutationVariables,
  APITypes.CreateEventPlayerResultMutation
>;
export const updateEventPlayerResult = /* GraphQL */ `mutation UpdateEventPlayerResult(
  $input: UpdateEventPlayerResultInput!
  $condition: ModelEventPlayerResultConditionInput
) {
  updateEventPlayerResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventPlayerResultMutationVariables,
  APITypes.UpdateEventPlayerResultMutation
>;
export const deleteEventPlayerResult = /* GraphQL */ `mutation DeleteEventPlayerResult(
  $input: DeleteEventPlayerResultInput!
  $condition: ModelEventPlayerResultConditionInput
) {
  deleteEventPlayerResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventPlayerResultMutationVariables,
  APITypes.DeleteEventPlayerResultMutation
>;
export const createLeague = /* GraphQL */ `mutation CreateLeague(
  $input: CreateLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  createLeague(input: $input, condition: $condition) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeagueMutationVariables,
  APITypes.CreateLeagueMutation
>;
export const updateLeague = /* GraphQL */ `mutation UpdateLeague(
  $input: UpdateLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  updateLeague(input: $input, condition: $condition) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeagueMutationVariables,
  APITypes.UpdateLeagueMutation
>;
export const deleteLeague = /* GraphQL */ `mutation DeleteLeague(
  $input: DeleteLeagueInput!
  $condition: ModelLeagueConditionInput
) {
  deleteLeague(input: $input, condition: $condition) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeagueMutationVariables,
  APITypes.DeleteLeagueMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createEventParticipant = /* GraphQL */ `mutation CreateEventParticipant(
  $input: CreateEventParticipantInput!
  $condition: ModelEventParticipantConditionInput
) {
  createEventParticipant(input: $input, condition: $condition) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventParticipantMutationVariables,
  APITypes.CreateEventParticipantMutation
>;
export const updateEventParticipant = /* GraphQL */ `mutation UpdateEventParticipant(
  $input: UpdateEventParticipantInput!
  $condition: ModelEventParticipantConditionInput
) {
  updateEventParticipant(input: $input, condition: $condition) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventParticipantMutationVariables,
  APITypes.UpdateEventParticipantMutation
>;
export const deleteEventParticipant = /* GraphQL */ `mutation DeleteEventParticipant(
  $input: DeleteEventParticipantInput!
  $condition: ModelEventParticipantConditionInput
) {
  deleteEventParticipant(input: $input, condition: $condition) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventParticipantMutationVariables,
  APITypes.DeleteEventParticipantMutation
>;
export const createEventStanding = /* GraphQL */ `mutation CreateEventStanding(
  $input: CreateEventStandingInput!
  $condition: ModelEventStandingConditionInput
) {
  createEventStanding(input: $input, condition: $condition) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventStandingMutationVariables,
  APITypes.CreateEventStandingMutation
>;
export const updateEventStanding = /* GraphQL */ `mutation UpdateEventStanding(
  $input: UpdateEventStandingInput!
  $condition: ModelEventStandingConditionInput
) {
  updateEventStanding(input: $input, condition: $condition) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventStandingMutationVariables,
  APITypes.UpdateEventStandingMutation
>;
export const deleteEventStanding = /* GraphQL */ `mutation DeleteEventStanding(
  $input: DeleteEventStandingInput!
  $condition: ModelEventStandingConditionInput
) {
  deleteEventStanding(input: $input, condition: $condition) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventStandingMutationVariables,
  APITypes.DeleteEventStandingMutation
>;
export const createMatch = /* GraphQL */ `mutation CreateMatch(
  $input: CreateMatchInput!
  $condition: ModelMatchConditionInput
) {
  createMatch(input: $input, condition: $condition) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMatchMutationVariables,
  APITypes.CreateMatchMutation
>;
export const updateMatch = /* GraphQL */ `mutation UpdateMatch(
  $input: UpdateMatchInput!
  $condition: ModelMatchConditionInput
) {
  updateMatch(input: $input, condition: $condition) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMatchMutationVariables,
  APITypes.UpdateMatchMutation
>;
export const deleteMatch = /* GraphQL */ `mutation DeleteMatch(
  $input: DeleteMatchInput!
  $condition: ModelMatchConditionInput
) {
  deleteMatch(input: $input, condition: $condition) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMatchMutationVariables,
  APITypes.DeleteMatchMutation
>;
export const createCommanderRound = /* GraphQL */ `mutation CreateCommanderRound(
  $input: CreateCommanderRoundInput!
  $condition: ModelCommanderRoundConditionInput
) {
  createCommanderRound(input: $input, condition: $condition) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommanderRoundMutationVariables,
  APITypes.CreateCommanderRoundMutation
>;
export const updateCommanderRound = /* GraphQL */ `mutation UpdateCommanderRound(
  $input: UpdateCommanderRoundInput!
  $condition: ModelCommanderRoundConditionInput
) {
  updateCommanderRound(input: $input, condition: $condition) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommanderRoundMutationVariables,
  APITypes.UpdateCommanderRoundMutation
>;
export const deleteCommanderRound = /* GraphQL */ `mutation DeleteCommanderRound(
  $input: DeleteCommanderRoundInput!
  $condition: ModelCommanderRoundConditionInput
) {
  deleteCommanderRound(input: $input, condition: $condition) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommanderRoundMutationVariables,
  APITypes.DeleteCommanderRoundMutation
>;
export const createCommanderPod = /* GraphQL */ `mutation CreateCommanderPod(
  $input: CreateCommanderPodInput!
  $condition: ModelCommanderPodConditionInput
) {
  createCommanderPod(input: $input, condition: $condition) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommanderPodMutationVariables,
  APITypes.CreateCommanderPodMutation
>;
export const updateCommanderPod = /* GraphQL */ `mutation UpdateCommanderPod(
  $input: UpdateCommanderPodInput!
  $condition: ModelCommanderPodConditionInput
) {
  updateCommanderPod(input: $input, condition: $condition) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommanderPodMutationVariables,
  APITypes.UpdateCommanderPodMutation
>;
export const deleteCommanderPod = /* GraphQL */ `mutation DeleteCommanderPod(
  $input: DeleteCommanderPodInput!
  $condition: ModelCommanderPodConditionInput
) {
  deleteCommanderPod(input: $input, condition: $condition) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommanderPodMutationVariables,
  APITypes.DeleteCommanderPodMutation
>;
export const createCommanderPodPlayer = /* GraphQL */ `mutation CreateCommanderPodPlayer(
  $input: CreateCommanderPodPlayerInput!
  $condition: ModelCommanderPodPlayerConditionInput
) {
  createCommanderPodPlayer(input: $input, condition: $condition) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommanderPodPlayerMutationVariables,
  APITypes.CreateCommanderPodPlayerMutation
>;
export const updateCommanderPodPlayer = /* GraphQL */ `mutation UpdateCommanderPodPlayer(
  $input: UpdateCommanderPodPlayerInput!
  $condition: ModelCommanderPodPlayerConditionInput
) {
  updateCommanderPodPlayer(input: $input, condition: $condition) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommanderPodPlayerMutationVariables,
  APITypes.UpdateCommanderPodPlayerMutation
>;
export const deleteCommanderPodPlayer = /* GraphQL */ `mutation DeleteCommanderPodPlayer(
  $input: DeleteCommanderPodPlayerInput!
  $condition: ModelCommanderPodPlayerConditionInput
) {
  deleteCommanderPodPlayer(input: $input, condition: $condition) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommanderPodPlayerMutationVariables,
  APITypes.DeleteCommanderPodPlayerMutation
>;
export const createEventTopCutResult = /* GraphQL */ `mutation CreateEventTopCutResult(
  $input: CreateEventTopCutResultInput!
  $condition: ModelEventTopCutResultConditionInput
) {
  createEventTopCutResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventTopCutResultMutationVariables,
  APITypes.CreateEventTopCutResultMutation
>;
export const updateEventTopCutResult = /* GraphQL */ `mutation UpdateEventTopCutResult(
  $input: UpdateEventTopCutResultInput!
  $condition: ModelEventTopCutResultConditionInput
) {
  updateEventTopCutResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventTopCutResultMutationVariables,
  APITypes.UpdateEventTopCutResultMutation
>;
export const deleteEventTopCutResult = /* GraphQL */ `mutation DeleteEventTopCutResult(
  $input: DeleteEventTopCutResultInput!
  $condition: ModelEventTopCutResultConditionInput
) {
  deleteEventTopCutResult(input: $input, condition: $condition) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventTopCutResultMutationVariables,
  APITypes.DeleteEventTopCutResultMutation
>;
